import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService} from 'compob2b-auth';
import {CreateUpdateFilesComponent} from './create-update/create-update-files.component';
import {DamCatalogComponent} from "./dam-table/dam-catalog.component";

const routes: Routes = [

  {
    path: '', // path is: cabinet/dam
    component: DamCatalogComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'item/create',
    component: CreateUpdateFilesComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'item/edit/:id',
    component: CreateUpdateFilesComponent,
    canActivate: [AuthGuardService]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FilesRoutingModule {
}
